<template>
  <div id="new-user" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-6">
          <!-- <el-breadcrumb separator="/">
            <el-breadcrumb-item>tienda</el-breadcrumb-item>
            <el-breadcrumb-item>gestión de usuarios</el-breadcrumb-item>
          </el-breadcrumb> -->
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="block">
      <label style="margin-bottom: 1rem">{{ subtitle }}</label>
      <el-form
        :model="user"
        name="newUserForm"
        :rules="rules"
        status-icon
        ref="newUserForm"
      >
        <div class="row">
          <div class="col-md-2">
            <el-form-item prop="business">
              <el-select
                v-model="user.business"
                placeholder="Empresa/Autónomo"
                @change="clearFields"
              >
                <el-option
                  v-for="item in businessSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-8" v-if="user.business">
            <el-form-item prop="socialDenomination">
              <el-input
                v-model="user.socialDenomination"
                autocomplete="off"
                placeholder="*Denominación social"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-8" v-else>
            <div class="row">
              <div class="col-md-6">
                <el-form-item prop="name">
                  <el-input
                    v-model="user.name"
                    autocomplete="off"
                    placeholder="*Nombre"
                    @focus="sessionExpired"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="col-md-6">
                <el-form-item prop="lastName">
                  <el-input
                    v-model="user.lastName"
                    autocomplete="off"
                    placeholder="*Apellidos"
                    @focus="sessionExpired"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <el-form-item prop="cifNif">
              <el-input
                v-model="user.cifNif"
                autocomplete="off"
                placeholder="*CIF/NIF"
                maxlength="10"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <el-form-item prop="email">
              <el-input
                type="email"
                :disabled="edit"
                v-model="user.email"
                autocomplete="off"
                placeholder="*Email"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item prop="phone">
              <el-input
                type="tel"
                v-model="user.phone"
                autocomplete="off"
                placeholder="*Teléfono"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <el-form-item prop="town">
              <el-input
                v-model="user.town"
                autocomplete="off"
                placeholder="*Población"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-7">
            <el-form-item prop="address">
              <el-input
                v-model="user.address"
                autocomplete="off"
                placeholder="*Dirección"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-form-item prop="postalCode">
              <el-input
                v-model="user.postalCode"
                autocomplete="off"
                placeholder="*Código postal"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row" style="margin-top: 30px;">
          <div class="col-md-6">
            <el-form-item prop="contactName">
              <el-input
                v-model="user.contactName"
                autocomplete="off"
                placeholder="Nombre de contacto (Opcional)"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item prop="contactLastName">
              <el-input
                v-model="user.contactLastName"
                autocomplete="off"
                placeholder="Apellido de contacto (Opcional)"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row" style="margin-top: 30px;">
          <div class="col-md-6">
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="user.password"
                autocomplete="off"
                placeholder="password"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6">
            <el-form-item prop="confirmPassword">
              <el-input
                type="password"
                v-model="user.confirmPassword"
                autocomplete="off"
                placeholder="confirm password"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <br />
        <label v-if="user && user.role === 'ROLE_ADMIN'">
          Aquí puedes cambiar la contraseña del usuario
        </label>
        <div class="row">
          <div class="col-lg-5" v-if="user && user.role === 'ROLE_ADMIN'">
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="user.password"
                autocomplete="off"
                placeholder="Contraseña"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-lg-5" v-if="user && user.role === 'ROLE_ADMIN'">
            <el-form-item prop="repeatPassword">
              <el-input
                type="password"
                v-model="user.repeatPassword"
                autocomplete="off"
                placeholder="Repetir contraseña"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-lg-2 text-right">
            <el-form-item prop="role">
              <el-select v-model="user.role" clearable placeholder="Rol">
                <el-option
                  v-for="item in roles"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <br />
        <div class="row" v-if="user && user.role === 'ROLE_USER'">
          <div class="col-md-4">
            <el-form-item
              prop="comercialName"
              :rules="[
                {
                  required: user.business,
                  message: 'Por favor rellena este campo',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="user.comercialName"
                autocomplete="off"
                placeholder="Nombre comercial"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row" v-if="user && user.id && coupon && coupon.coupon">
          <div class="col-md-4">
            <el-form-item label="Identificador de punto de venta">
              <el-input
                readonly
                disabled
                v-model="coupon.coupon"
                autocomplete="off"
                placeholder="Identificador de punto de venta"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <br />
        <span>Los campos marcados con (*) son obligatorios</span>
        <hr />
        <div class="row">
          <div class="col-12 text-right">
            <el-button class="btn btn_secondary" @click="goRoute('user')">
              Volver
            </el-button>
            <el-button class="btn btn_gradient" @click="saveUser">
              Guardar cambios
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <Modal
      v-if="showModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        showModal = false;
        titleModal = '';
      "
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            Los datos se han guardado correctamente
          </label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="showModal = false"
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de aviso acerca de los errores en el formulario -->
    <Modal
      v-if="errorShowModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        errorShowModal = false;
        errorsModal = null;
      "
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <div class="errorsModal">
            <div v-if="errorsModal">
              <label>Los siguientes campos no están correctos:</label>
              <ul style="margin:0;padding:0;">
                <li v-for="(message, index) in errorsModal" :key="index">
                  <span style="color: white">{{ message }}</span>
                </li>
              </ul>
            </div>
          </div>
          <button
            class="btn"
            style="margin: 12px 0px 0px 0px"
            @click="
              errorShowModal = false;
              errorsModal = null;
            "
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
// Components
import Modal from "@/components/Modal";

import AuthService from "@/services/auth.service";
import UserService from "@/services/user.service";
import User from "../../model/User";

import { mapState } from "vuex";
import { Loading } from "element-ui";
export default {
  name: "NewUser",
  components: { Modal },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  data() {
    const nameRule = (rule, value, callback) => {
      if (!this.user.business && !value) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        callback();
      }
    };
    const lastNameRule = (rule, value, callback) => {
      if (!this.user.business && !value) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        callback();
      }
    };
    const socialDenominationRule = (rule, value, callback) => {
      if (this.user.business && !value) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        callback();
      }
    };
    const passRule = (rule, value, callback) => {
      if (!value && rule.required === true) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        if (value && value.length < 8) {
          callback(
            new Error("La contraseña debe tener como mínimo 8 caracteres")
          );
        } else if (this.user.repeatPassword) {
          this.$refs.newUserForm.validateField("repeatPassword");
          callback();
        } else {
          callback();
        }
      }
    };
    const repeatPassRule = (rule, value, callback) => {
      if (!value && rule.required === true) {
        callback(new Error("Por favor rellena este campo"));
      } else if (value !== this.user.password) {
        callback(new Error("Las contraseñas no coinciden"));
      } else {
        callback();
      }
    };
    const phoneRule = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error("Por favor rellena este campo"));
        return;
      }

      if (!Number(value)) {
        callback(new Error("El campo debería de ser un número"));
        return;
      }

      if (value.length < 9 || value.length > 9) {
        callback(new Error("La longitud ha de ser de 9 digitos"));
        return;
      }
      if (Number(value.substr(0, 1)) < 6 || Number(value.substr(0, 1)) > 9) {
        callback(
          new Error("El número de teléfono ha de empezar por 6, 7 , 8 o 9")
        );
      } else {
        callback();
      }
    };

    return {
      title: "GESTIÓN DE USUARIOS",
      subtitle: "",
      showModal: false,
      coupon: null,
      edit: false,
      user: {
        name: null,
        lastName: null,
        phone: null,
        email: null,
        repeatPassword: null,
        address: null,
        town: null,
        business: true,
        postalCode: null,
        socialDenomination: null,
        cifNif: null,
        contactName: null,
        contactLastName: null,
        password: null,
        confirmPassword: null,
        role: "ROLE_USER",
        comercialName: null
      },
      roles: [
        {
          label: "USUARIO",
          value: "ROLE_USER"
        },
        {
          label: "ADMINISTRADOR",
          value: "ROLE_ADMIN"
        }
      ],
      businessSelect: [
        {
          label: "EMPRESA",
          value: true
        },
        {
          label: "AUTÓNOMO",
          value: false
        }
      ],
      errorsTranslate: {
        name: "Nombre",
        lastName: "Apellidos",
        socialDenomination: "Denominación social",
        cifNif: "CIF/NIF",
        email: "Email",
        phone: "Teléfono",
        town: "Población",
        address: "Dirección",
        postalCode: "Código postal",
        password: "Contraseña",
        repeatPassword: "Repetir contraseña",
        role: "Rol",
        comercialName: "Nombre comercial"
      },
      rules: {
        name: {
          validator: nameRule,
          trigger: "blur"
        },
        lastName: {
          validator: lastNameRule,
          trigger: "blur"
        },
        socialDenomination: {
          validator: socialDenominationRule,
          trigger: "blur"
        },
        cifNif: {
          required: true,
          message: "Por favor rellena este campo",
          trigger: "blur"
        },
        email: {
          type: "email",
          required: true,
          message: "Por favor introduce un email válido",
          trigger: "blur"
        },
        phone: {
          required: true,
          validator: phoneRule,
          trigger: "blur"
        },
        town: {
          required: true,
          message: "Por favor rellena este campo",
          trigger: "blur"
        },
        address: {
          required: true,
          message: "Por favor rellena este campo",
          trigger: "blur"
        },
        postalCode: {
          required: true,
          message: "Por favor rellena este campo",
          trigger: "blur"
        },
        password: {
          required: true,
          validator: passRule,
          trigger: "blur"
        },
        repeatPassword: {
          required: true,
          validator: repeatPassRule,
          trigger: "blur"
        },
        role: {
          required: true,
          message: "",
          trigger: "blur"
        }
      },
      errorShowModal: false,
      errorsModal: null
    };
  },
  mounted() {
    this.sessionExpired();
    document.querySelector("#app").scrollTop = 0;
    if (this.$route.params.id && this.$route.params.id !== "new") {
      this.subtitle = "EDITAR USUARIO";
      this.edit = true;
      this.rules.password.required = false;
      this.rules.repeatPassword.required = false;
      UserService.findById(this.$route.params.id)
        .then(response => {
          this.user = response.data.data;
          this.coupon = this.user.coupon;
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message: "No se ha encontrado este usuario",
            type: "error",
            duration: 3000
          });
          this.$router.push("/new-client");
        });
    } else {
      this.subtitle = "NUEVO USUARIO";
    }
  },
  methods: {
    sessionExpired() {
      AuthService.sessionExpired();
    },
    saveUser() {
      this.$refs["newUserForm"].validate((valid, errors) => {
        if (valid) {
          const loadingInstance = Loading.service({ fullscreen: true });
          if (this.user.id) {
            UserService.updateUser(
              new User(
                this.user.id,
                this.user.name,
                this.user.lastName,
                this.user.socialDenomination,
                this.user.email,
                this.user.phone,
                this.user.town,
                this.user.address,
                this.user.postalCode,
                this.user.cifNif,
                this.user.contactName,
                this.user.contactLastName,
                this.user.role,
                this.user.password,
                this.user.business,
                this.user.comercialName
              )
            )
              .then(() => {
                this.showModal = true;
                loadingInstance.close();
                this.$router.push({ name: "user" });
              })
              .catch(() => {
                this.$notify({
                  title: "Error",
                  message: "Error actualizando el usuario",
                  type: "error",
                  duration: 3000
                });
                loadingInstance.close();
              });
          } else {
            UserService.saveUser(
              new User(
                null,
                this.user.name,
                this.user.lastName,
                this.user.socialDenomination,
                this.user.email,
                this.user.phone,
                this.user.town,
                this.user.address,
                this.user.postalCode,
                this.user.cifNif,
                this.user.contactName,
                this.user.contactLastName,
                this.user.role,
                this.user.password,
                this.user.business,
                this.user.comercialName
              )
            )
              .then(() => {
                this.showModal = true;
                loadingInstance.close();
                this.$router.push({ name: "user" });
              })
              .catch(error => {
                this.$notify({
                  title: "Error",
                  message:
                    error.response.status === 400
                      ? "El email ya existe"
                      : "No se ha podido crear el usuario",
                  type: "error",
                  duration: 3000
                });
                loadingInstance.close();
              });
          }
        } else {
          const messages = [];
          Object.keys(errors).forEach(key => {
            messages.push(this.errorsTranslate[key]);
          });
          this.errorShowModal = true;
          this.errorsModal = messages;
          return false;
        }
      });
    },
    resetPassword() {
      UserService.rememberPassword(this.user.email).then(() => {
        this.$notify({
          title: "OK",
          message:
            "Se le ha enviado un email al usuario con su nueva contraseña",
          type: "success",
          duration: 3000
        });
      });
    },
    clearFields() {
      this.user.name = null;
      this.user.lastName = null;
      this.user.socialDenomination = null;
    },
    goRoute(route) {
      this.$router.push({ name: route });
    }
  }
};
</script>

<style lang="scss" scoped>
#new-user {
  width: 100%;
  height: auto;
}

@media (max-width: 992px) {
  #new-user {
    .el-select {
      width: 100%;
    }
  }
}
</style>
